import type { DocEntityHandle } from "building-types/handles/docEntityHandleTypes";
import type { UVTransformation } from "geom/uv";
import { UVGeneration, uvIdentityXForm } from "geom/uv";

export function uvGenerationForSweep(_materialTransformation?: UVTransformation): UVGeneration {
  return UVGeneration.GLOBAL_RECT_UV;
  // TODO if we agree on it:
  // return materialTransformation?.rotationDegrees !== undefined
  //   ? UVGeneration.GLOBAL_RECT_UV
  //   : UVGeneration.LONGITUDINAL_U;
}

export function uvGenerationForRoofCap() {
  // TODO: once the cap faces are unified after BSP clipping, or when we don't use BSP clipping anymore
  //  return UVGeneration.LONGITUDINAL_U;
  return UVGeneration.NONE; // This still heavily relies on how the face geometries are created.
}

export function uvTransformationForRoofCap(): UVTransformation {
  return uvIdentityXForm;
}

export function uvGenerationForRoofTrim() {
  // TODO: when we figure out what to do with trims that are legitimately shorter than tall
  //  return UVGeneration.LONGITUDINAL_U;
  return UVGeneration.NONE;
}

export function uvGenerationForWallPlaneTrim(): UVGeneration {
  return UVGeneration.NONE;
}

export function uvGenerationForWallBRep(
  entityHandle: DocEntityHandle | undefined,
  materialTransformation?: UVTransformation,
): UVGeneration {
  if (entityHandle?.type === "WALL_PLANE_TRIM") {
    return uvGenerationForWallPlaneTrim();
  }
  return uvGenerationForSweep(materialTransformation);
}

export function uvGenerationForInfill() {
  return UVGeneration.LONGITUDINAL_U;
}

export function uvGenerationForRailingPost() {
  return UVGeneration.LONGITUDINAL_U;
}

export function uvGenerationForRailingRail() {
  return UVGeneration.LONGITUDINAL_U;
}

export function uvGenerationForWindowShutter() {
  return UVGeneration.LONGITUDINAL_U;
}

export function uvGenerationForStairStringer() {
  return UVGeneration.LONGITUDINAL_U;
}

export function uvGenerationForStairProfile() {
  return UVGeneration.LONGITUDINAL_U;
}

export function uvGenerationForStairTread() {
  return UVGeneration.LONGITUDINAL_U;
}

export function uvGenerationForStairRiser() {
  return UVGeneration.LONGITUDINAL_U;
}

export function uvGenerationForColumnSection(materialRotation?: number): UVGeneration {
  return materialRotation !== undefined ? UVGeneration.GLOBAL_RECT_UV : UVGeneration.LONGITUDINAL_U;
}

export function uvTransformationForColumnSection(materialRotation?: number): UVTransformation | undefined {
  return materialRotation ? { uTranslation: 0, vTranslation: 0, rotationDegrees: materialRotation } : undefined;
}
